import { Router } from "@angular/router";
import { HttpDomainExtractor } from "../helpers/extract-http-domain.helper";
import { APP_KEY_QUERY_PARAM, BACK_LINK_REDIRECT_QUERY_PARAM, BACK_LINK_REDIRECT_QUERY_PARAM_MOBILE, DEFAULT_BACKLINK_REDIRECT_PATTERN, DEFAULT_BACKLINK_REDIRECT_PATTERN_WITH_ACCESS_TOKEN, HTTP_SCHEMA_MOBILE_APP, IS_MOBILE_BACK_LINK_QUERY_PARAM, LEGACY_APP_KEY_QUERY_PARAM, LOGIN_MOBILE_ROUTE, MOBILE_DEFAULT_BACKLINK_REDIRECT_PATTERN, REDIRECT_DEFAULT_THIRD_PARTY_REDIRECT_PATTERN, REDIRECT_QUERY_PARAM, REQUEST_AUTHORIZE_CODE_ROUTE, SSO_CLIENT_ID_APP_KEY_MAP, SSO_WEB_CLIENT_ID_QUERY_PARAM } from "@features/auth/const";
import { AuthService, StorageHelper } from "@features/auth/public-api";

/**
 * Neu co backlink thi redirect ve link do sau khi dang nhap thanh cong
 * Truong hop khong co thi xu ly binh truong
 * Luog goi backlink voi authorization code
 */
export function getBackLinkToken(router: Router, token: string, backLinkQueryParam = BACK_LINK_REDIRECT_QUERY_PARAM, redirectQueryParam = REDIRECT_QUERY_PARAM, domainStartWith = 'http', pattern = DEFAULT_BACKLINK_REDIRECT_PATTERN) {
  const currentQueryParams = router.routerState.snapshot.root.queryParams;
  const backLink = currentQueryParams[backLinkQueryParam];
  const redirect = currentQueryParams[redirectQueryParam] || '';
  const buildRedirectPattern = (thirdPartyBackLink: string, token: string) => {
    // const { domain, path } = HttpDomainExtractor.extractDomain(thirdPartyBackLink, domainStartWith)
    // Fixed: Update to get redirect URL From storaate instead of get from query pararm
    const domain = StorageHelper.getSSOWebRedirecURI();
    return pattern.replace('{domain}', domain).replace('{authorization_code}', token).replace('{path}', redirect);
  }
  return buildRedirectPattern(backLink, token);
}

// Luong goi backlink voi access token de ben kia login token.
export function getBackLinkTokenWithAccessToken(router: Router, token: string, backLinkQueryParam = BACK_LINK_REDIRECT_QUERY_PARAM, domainStartWith = 'http', pattern = DEFAULT_BACKLINK_REDIRECT_PATTERN_WITH_ACCESS_TOKEN) {
  const currentQueryParams = router.routerState.snapshot.root.queryParams;
  const backLink = currentQueryParams[backLinkQueryParam];
  const buildRedirectPattern = (thirdPartyBackLink: string, token: string) => {
    const { domain, path } = HttpDomainExtractor.extractDomain(thirdPartyBackLink, domainStartWith)
    return pattern.replace('{domain}', domain).replace('{token}', token).replace('{path}', backLink);
  }
  return buildRedirectPattern(backLink, token);
}

export function getBackLinkMobileToken(router: Router, authorization_code: string, backLinkQueryParam = BACK_LINK_REDIRECT_QUERY_PARAM, domainStartWith = 'http', pattern = MOBILE_DEFAULT_BACKLINK_REDIRECT_PATTERN) {
  const currentQueryParams = router.routerState.snapshot.root.queryParams;
  const backLink = currentQueryParams[backLinkQueryParam];
  const buildRedirectPattern = (backLink: string, authorization_code: string) => {
    return pattern.replace('{domain}', backLink).replace('{authorization_code}', authorization_code);
  }
  return buildRedirectPattern(backLink, authorization_code);
}
// Go to page with existing and new query params
export const navigateWithQueryParams = (router: Router, path: string[], queryParams?: { [key: string]: any }) => {
  const currentQueryParams = router.routerState.snapshot.root.queryParams;
  const mergedQueryParams = { ...currentQueryParams, ...queryParams };
  router.navigate(path, { queryParams: mergedQueryParams });
}


export const isExistBackLink = (router: Router): boolean => {
  const currentQueryParams = router.routerState.snapshot.root.queryParams;
  return !!currentQueryParams[BACK_LINK_REDIRECT_QUERY_PARAM];
}

export const isExistMobileBackLink = (router: Router): boolean => {
  const currentQueryParams = router.routerState.snapshot.root.queryParams;
  const appKey = currentQueryParams[APP_KEY_QUERY_PARAM] || currentQueryParams[LEGACY_APP_KEY_QUERY_PARAM] || '';
  return currentQueryParams[BACK_LINK_REDIRECT_QUERY_PARAM_MOBILE] &&
    appKey !== '';
}

export const getAppKeyQueryParam = (router: Router, clientIdAppKeyMap: { [key: string]: { app_key: string, redirect_uri: string } } = SSO_CLIENT_ID_APP_KEY_MAP): string => {
  const currentQueryParams = router.routerState.snapshot.root.queryParams;
  const appKeyFromQuery = currentQueryParams[APP_KEY_QUERY_PARAM] || '';
  if (appKeyFromQuery) {
    return appKeyFromQuery;
  }

  const clientId = currentQueryParams[SSO_WEB_CLIENT_ID_QUERY_PARAM] || currentQueryParams[LEGACY_APP_KEY_QUERY_PARAM] || '';
  const appKeyMapped = clientIdAppKeyMap[clientId]?.app_key || '';
  if (!appKeyMapped) {
    console.warn(`[404] Can not map client id ${clientId} to app key`);
  }
  return appKeyMapped;
}

// Logic chuye huog khi co backlink
// Truong hop khog dung logic backlinnk thhi chuyen huong binh thuong
export const navigateToBackLink = (router: Router, authorizeMode: 'token' | 'authen_code') => {
  if (isExistMobileBackLink(router)) {
    const url = getBackLinkMobileToken(router, StorageHelper.getSSOMobileAuthorizationCode() || '', BACK_LINK_REDIRECT_QUERY_PARAM_MOBILE, HTTP_SCHEMA_MOBILE_APP);
    window.location.href = url;
    return;
  }

  // Case web;
  if (isExistBackLink(router)) {
    if (authorizeMode === 'authen_code') {
      window.location.href = getBackLinkToken(router, StorageHelper.getSSOWebAuthorizationCode() || '');
      return;
    }
    window.location.href = getBackLinkTokenWithAccessToken(router, StorageHelper.getAccessToken() || '');
    return;
  }

  window.location.href = StorageHelper.getCallBackURL();
}

// Khi chuyen den trang sso - cos truyen app key thi toan bo site sso se chay theo app key nay.
export const setAppKeyToStorageWhenRedirectWithQueryParam = (router: Router) => {
  const appKey = getAppKeyQueryParam(router);

  if (appKey) {
    StorageHelper.setAppKey(appKey);
  }
}

// Lick chuyen ve domain cua cac site khac kem auth code
// Dungf trong casc module can chuyen huong ve site khac
// @param additionQuery - Query string bo sung se duoc noi vao cuoi URL redirect (VD: '&app_key=MOBILE_HUTECH')
export const redirectToThirdPartySite = (domain: string, authen_code: string, redirect?: string, pattern = REDIRECT_DEFAULT_THIRD_PARTY_REDIRECT_PATTERN, additionQuery?: string) => {
  let redirectUrl = pattern.replace('{domain}', domain).replace('{authorization_code}', authen_code).replace('{path}', redirect || '');
  // Noi them query string bo sung neu co
  if (additionQuery) {
    redirectUrl += additionQuery;
  }

  console.log(`[RedirectHelper] Redirect to third party site: ${redirectUrl}`);

  window.location.href = redirectUrl;
}


// @param additionQuery - Luu vao query param 'addition_query' de truyen qua trang request authorize code
export const redirectToRequesstAuthorizeCodePage = (router: Router, clientID: string, backlinkOrDomain: string, redirect: string, additionQuery?: string) => {
  const queryParams: any = {
    [SSO_WEB_CLIENT_ID_QUERY_PARAM]: clientID,
    [BACK_LINK_REDIRECT_QUERY_PARAM]: backlinkOrDomain,
    [REDIRECT_QUERY_PARAM]: redirect,
  };
  // Truyen additionQuery qua query param de page request-authorize-code doc lai
  if (additionQuery) {
    queryParams['addition_query'] = additionQuery;
  }
  return router.navigate([REQUEST_AUTHORIZE_CODE_ROUTE], { queryParams });
}
